import {
  Autocomplete,
  Avatar,
  Badge,
  Card,
  Chip,
  Grid,
  Icon,
  List,
  ListItem,
  ListItemAvatar,
  ListItemButton,
  ListItemText,
  Stack,
  TextField,
  Typography
} from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import {
  FETCH_USER_TEMP_EMAILS,
  GET_RECENTLY_USERS,
  SEARCH_USERS_MEMBERS
} from "../../constant/Apipath";
import { Getrequestcall } from "../../request/Getrequest";
import { useSelector } from "react-redux";
import CheckIcon from "@mui/icons-material/Check";
import Removeduplicates from "./Removeduplicate";
import UseDebounce from "./UseDebounce";
import { Postrequestcall } from "../../request/Postrequest";
import PlaceholderImg from "../../assets/images/avtar_placeholder.jpeg";
import Loader from "../../common/Loader";
import { English } from "../../constant/EnglishFallback";
const ShareModule = ({ selectedEmails, setSelectedEmails, from }) => {
  const [recentUsers, setRecentusers] = useState([]);
  const { loginData, multiLanguageData } = useSelector((state) => state?.main);
  const [searchContact, setSearchContact] = useState("");
  const [membersList, setMembersList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [tempUserEmail, setTempUserEmail] = useState([]);

  const debouncedEmail = UseDebounce(searchContact, 500);

  const {
    TEXT_RECIPIENTS = English?.Tickets?.TEXT_RECIPIENTS,
    TEXT_SORT_BY_RECENT = English?.Tickets?.TEXT_SORT_BY_RECENT,
    TEXT_ADD_EMAIL_PLACEHOLDER = English?.Tickets?.TEXT_ADD_EMAIL_PLACEHOLDER
  } = multiLanguageData?.Tickets || {};

  const getSearchUserList = useCallback(async () => {
    try {
      const getEmailsObject = {
        PageNr: 0,
        NrOfRecPerPage: 0,
        FullSearch: "",
        UserId: loginData?.userInformation?.UserId,
        IncludeRecordNr: true,
        TypeOfObjectReturned: "",
        SearchList: [{ CreatedBy: loginData?.userInformation?.UserId }],
        SortList: [{}]
      };
      const getEmails = await Postrequestcall(
        FETCH_USER_TEMP_EMAILS,
        getEmailsObject,
        loginData?.accessToken
      );
      if (getEmails?.status === 201) {
        const newFilterData = Removeduplicates(getEmails?.data?.data, "tempEmail");
        let b = [];
        const newData = newFilterData.map((item) => {
          b = item;
          b["isSelected"] = false;
          b["isChipSelected"] = false;
          b["contactEmail"] = item.tempEmail;
          b["contactPictureUrl"] = PlaceholderImg;
          b["contactId"] = 0;
          b["contactName"] = item.tempEmail;
          return b;
        });

        if (from !== "ShareTickets") {
          setMembersList(newData);
        }
        setTempUserEmail(newFilterData);
      }
    } catch (error) {
      console.log("getSearchUserList-> Error When Getting Search User List: ", error);
    }
  }, []);

  const getMembersList = useCallback(async (searchValue, tempEmaildata, selectedEmails) => {
    try {
      setLoading(true);
      let getUserMemberResponse = await Getrequestcall(
        `${SEARCH_USERS_MEMBERS}/${loginData?.userInformation?.UserId}/${0}/${searchValue}`,
        loginData?.accessToken
      );
      if (getUserMemberResponse?.data?.data?.length > 0) {
        const newData = Removeduplicates(getUserMemberResponse?.data?.data, "userEmail");

        let a = [];
        const newContacts = newData.map((cont) => {
          a = cont;
          a["isSelected"] = false;
          a["isChipSelected"] = false;
          a["contactEmail"] = cont.userEmail;
          a["contactPictureUrl"] = cont.pictureUrl;
          a["contactId"] = cont.userId;
          a["contactName"] = cont.firstName + " " + cont.lastName;
          return a;
        });

        let b = [];
        const newData1 = tempEmaildata.map((item) => {
          b = item;
          b["isSelected"] = false;
          b["isChipSelected"] = false;
          b["contactEmail"] = item.tempEmail;
          b["contactPictureUrl"] = PlaceholderImg;
          b["contactId"] = 0;
          b["contactName"] = item.tempEmail;
          return b;
        });

        const finalContacts = [...newData1, ...newContacts];

        const finalContactsData = Removeduplicates(finalContacts, "contactEmail");

        if (selectedEmails.length != 0) {
          const emailsToRemove = selectedEmails.map((obj) => obj.contactEmail);
          // Using for loop to remove objects
          for (let i = finalContactsData.length - 1; i >= 0; i--) {
            if (emailsToRemove.includes(finalContactsData[i].contactEmail)) {
              finalContactsData.splice(i, 1); // Remove the object from the array
            }
          }
          setMembersList(finalContactsData);
        } else {
          setMembersList(finalContactsData);
        }
        if (finalContactsData?.length == 0) {
          setLoading(false);
        }
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      console.log("getMembersList-> Error When Getting Members List: ", error);
    }
  }, []);

  const getRecentInteractUsers = async () => {
    try {
      setIsLoading(true);
      const getUsersresponse = await Getrequestcall(
        GET_RECENTLY_USERS + "/" + loginData?.userInformation?.UserId,
        loginData?.accessToken
      );
      if (getUsersresponse?.status === 200) {
        let getRecentusers = getUsersresponse?.data?.data?.map((item) => ({
          ...item,
          checked: false,
          contactEmail: item?.interactUserEmail,
          contactId: item?.interactUserId,
          title: item?.interactUserName
        }));
        setRecentusers(getRecentusers);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.log("getRecentInteractUsers-> Error When Getting Recent Interaction Users: ", error);
    }
  };

  useEffect(() => {
    getRecentInteractUsers();
    getSearchUserList();
  }, []);

  useEffect(() => {
    if (debouncedEmail && from === "ShareTickets") {
      getMembersList(debouncedEmail, tempUserEmail, selectedEmails);
    }
  }, [debouncedEmail]);

  const validateEmail = (email) => {
    const emailRegex =
      /^[a-zA-Z][a-zA-Z0-9]*(\+[a-zA-Z0-9]+)?(\.[a-zA-Z0-9]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,6}$/;
    return emailRegex.test(email);
  };

  const onHandleChangeContact = (event, newvalue) => {
    if (newvalue?.length == 0) {
      if (from === "ShareTickets") {
        setMembersList([]);
      } else {
        setMembersList(tempUserEmail);
      }
      let getRecentusers = recentUsers.map((item) => ({
        ...item,
        checked: false,
        isChipSelected: false,
        isSelected: false
      }));
      setRecentusers(getRecentusers);
      setSelectedEmails([]);
    } else {
      if (event.key === "Enter") {
        event.preventDefault();
        if (validateEmail(searchContact)) {
          if (!selectedEmails.some((item) => item.contactEmail === searchContact)) {
            setSelectedEmails([
              ...selectedEmails,
              {
                contactEmail: searchContact,
                title: searchContact
              }
            ]);
          }
        }
      } else {
        let getUpdatedlist = recentUsers.map((item) =>
          item.contactId === newvalue[0].contactId
            ? { ...item, checked: true, isChipSelected: true, isSelected: true }
            : item
        );

        setRecentusers(getUpdatedlist);

        const updatedNewValue = newvalue.map((item) => ({
          ...item,
          isSelected: true,
          isChipSelected: true,
          checked: true
        }));
        setSelectedEmails(updatedNewValue);
      }
    }
  };

  const onHandleInputChange = (event, newvalue) => {
    if (from !== "ShareTickets") {
      let finalContactsData = membersList;
      if (selectedEmails.length != 0) {
        const emailsToRemove = selectedEmails.map((obj) => obj.contactEmail);
        // Using for loop to remove objects
        for (let i = finalContactsData.length - 1; i >= 0; i--) {
          if (emailsToRemove.includes(finalContactsData[i].contactEmail)) {
            finalContactsData.splice(i, 1); // Remove the object from the array
          }
        }
        setMembersList(finalContactsData);
      }
    }
    setSearchContact(newvalue);
  };

  const handleDeleteChip = (emailToDelete) => {
    setSelectedEmails((prev) => prev.filter((email) => email !== emailToDelete)); // Remove chip
  };

  const onRecentclick = (getItem) => {
    let getList = [...selectedEmails];
    let getUpdatedlist = recentUsers.map((item) =>
      item.id === getItem.id
        ? { ...item, checked: !item.checked, isChipSelected: !item.checked }
        : item
    );

    let selectedUser = getUpdatedlist.find((item) => item.id === getItem.id);

    if (selectedUser?.isChipSelected) {
      let isSelected = getList.some((item) => item.contactEmail === selectedUser.contactEmail);
      if (!isSelected) {
        getList.push(selectedUser);
      }
    } else {
      getList = getList.filter((item) => item.contactEmail !== selectedUser.contactEmail);
    }

    setSelectedEmails(getList);
    setRecentusers(getUpdatedlist);
  };

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <Stack gap={1}>
          <Typography variant="body1" fontWeight={"bold"}>
            {TEXT_RECIPIENTS}
          </Typography>
          <Stack>
            <Autocomplete
              size="small"
              multiple
              freeSolo
              open={searchContact?.length > 1}
              options={
                membersList.length > 0 ? membersList.filter((member) => !member.isChipSelected) : []
              }
              value={selectedEmails}
              noOptionsText="No locations"
              includeInputInList
              filterSelectedOptions
              getOptionLabel={(option) => `${option.contactName} (${option.contactEmail})`}
              filterOptions={(options, { inputValue }) =>
                options.filter(
                  (option) =>
                    option.contactName.toLowerCase().includes(inputValue.toLowerCase()) ||
                    option.contactEmail.toLowerCase().includes(inputValue.toLowerCase())
                )
              }
              onInputChange={(event, newInputValue) => onHandleInputChange(event, newInputValue)}
              onChange={(event, newValue) => onHandleChangeContact(event, newValue)}
              renderOption={(props, option) => (
                <List {...props} key={option?.contactEmail} disablePadding>
                  <ListItem disablePadding>
                    <ListItemAvatar>
                      <Avatar alt="contact-PictureUrl" src={option?.contactPictureUrl} />
                    </ListItemAvatar>
                    <ListItemText primary={option?.contactName} secondary={option?.contactEmail} />
                  </ListItem>
                </List>
              )}
              renderTags={(value, getTagProps) =>
                value.map((option, index) => {
                  const { key, ...tagProps } = getTagProps({ index });
                  return (
                    <Chip
                      variant="outlined"
                      label={option.contactEmail}
                      key={key}
                      {...tagProps}
                      onDelete={() => handleDeleteChip(option)}
                    />
                  );
                })
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  label={TEXT_ADD_EMAIL_PLACEHOLDER}
                  // placeholder={TEXT_ADD_EMAIL_PLACEHOLDER}
                />
              )}
            />
          </Stack>
          {recentUsers?.length !== 0 && (
            <>
              <Typography variant="body1" fontWeight={"bold"}>
                {TEXT_SORT_BY_RECENT}{" "}
              </Typography>
              <List disablePadding>
                <Grid container spacing={1} columns={{ xs: 12, sm: 12, md: 12 }}>
                  {recentUsers.map((item, index) => (
                    <Grid key={index} size={{ xs: 4, sm: 4, md: 4 }}>
                      <Card className="pagelist-content" sx={{ mt: 0 }}>
                        <ListItemButton
                          alignItems="center"
                          sx={{ m: 0, p: 1 }}
                          onClick={() => onRecentclick(item)}>
                          <Badge
                            overlap="circular"
                            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                            badgeContent={
                              selectedEmails.some(
                                (selectedUser) => selectedUser.contactEmail === item.contactEmail
                              ) ? (
                                <Icon
                                  disabled
                                  sx={{
                                    borderRadius: "50px",
                                    backgroundColor: "#083DB8",
                                    color: "white",
                                    width: 20,
                                    height: 20
                                  }}>
                                  <CheckIcon fontSize="small" />
                                </Icon>
                              ) : null
                            }>
                            <Avatar alt="Travis Howard" src={item?.interactUserImageUrl} />
                          </Badge>
                          <ListItemText
                            sx={{ pl: 1, m: 0 }}
                            primary={
                              <Typography variant="body1" maxWidth={"120px"} noWrap>
                                {item?.interactUserName}
                              </Typography>
                            }
                            secondary={
                              <Typography
                                variant="body2"
                                color="textSecondary"
                                maxWidth={"120px"}
                                noWrap>
                                {" "}
                                {item?.interactUserTradeName}
                              </Typography>
                            }
                          />
                        </ListItemButton>
                      </Card>
                    </Grid>
                  ))}
                </Grid>
              </List>
            </>
          )}
        </Stack>
      )}
    </>
  );
};

export default ShareModule;
